module.exports = __webpack_public_path__ + "img/original-quality-rubber-stamp.1565eb3b.jpg";